import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Link } from 'react-router-dom';
import TikTokIcon from '../components/icons/TikTokIcon';

export const Footer = () => {
  const { dispatch } = useApp();

  // Check if we're in standalone mode (PWA)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone;

  // If in standalone mode, don't render the footer
  if (isStandalone) {
    return null;
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Logo Section */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-2xl font-bold text-pink-500">Shynerz</span>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <p className="text-gray-400 mb-4">
              Your one-stop shop for all baby essentials in Kenya.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/shynerzbabyshop?mibextid=ZbWKwL" className="text-gray-400 hover:text-pink-500">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="https://www.instagram.com/shynerzbabyshop/" className="text-gray-400 hover:text-pink-500">
                <Instagram className="h-6 w-6" />
              </a>
              <a href="https://www.tiktok.com/@shynerz.baby.shop" className="text-gray-400 hover:text-pink-500">
                <TikTokIcon className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-pink-500 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/shop"
                  className="text-gray-400 hover:text-pink-500 transition-colors"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-pink-500 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-pink-500 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-pink-500">My Account</a></li>
              <li><a href="#" className="text-gray-400 hover:text-pink-500">Track Order</a></li>
              <li><a href="#" className="text-gray-400 hover:text-pink-500">Returns Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-pink-500">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-pink-500" />
                <span className="text-gray-400">Crystal Center at Thindugua Stage, Kiambu Road</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-pink-500" />
                <span className="text-gray-400">+254 759 409139</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-pink-500" />
                <span className="text-gray-400">sales.shynerz@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links Section */}
        <div className="border-t border-gray-800">
          <div className="container mx-auto px-4 py-4">
            <div className="flex flex-wrap justify-center space-x-6 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/faq" className="hover:text-white transition-colors">
                FAQ
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-800">
          <div className="container mx-auto px-4 py-4">
            <div className="flex flex-col items-center space-y-2">
              <p className="text-sm text-gray-400 text-center">
                © 2025 Shynerz Baby Shop. All rights reserved.
              </p>
              <p className="text-sm text-gray-400">
                Powered by{' '}
                <a 
                  href="https://tybritelabs.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  TYBRITE LABS
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};